import BaseButton from 'base-components/BaseButton/BaseButton';
import BaseModal from 'base-components/BaseModal/BaseModal';
import { Dispatch, SetStateAction } from 'react';
import {  ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import BaseForm from 'base-components/BaseForm/BaseForm';
import BaseValidatedInput from 'base-components/BaseValidatedInput/BaseValidatedInput';
import { requiredRule } from 'rules/validateRules';
import BaseValidatedDropDownList from 'base-components/BaseValidatedDropDownList/BaseValidatedDropDownList';
import 'scss/Main.scss';
import { DefaultValues, FieldValues } from 'react-hook-form';
import { PLATFORMS, STATUSES } from 'utils/consts';
import { useToastContext } from 'providers/ToastProvider';

type VersionChangeModalProps<T> = {
    isOpen?: boolean;
    toggle: Dispatch<SetStateAction<boolean>>;
    employeeId?: number;
    isEditing?: boolean;
    handleChange: (form: T, shouldUpdateBody?: boolean, shouldUpdateStatus?: boolean) => void;
    editableRow?: DefaultValues<T>,
};

const VersionsEditModal = <T extends FieldValues,>({ isOpen = false, toggle, editableRow, handleChange, isEditing }: VersionChangeModalProps<T>) => {
    const toasts = useToastContext();

    const defaultValues = editableRow ?? {} as DefaultValues<T>;

    const handleSubmit = (form: T) => {
        const shouldUpdateBody = form.description !== defaultValues.description || form.name !== defaultValues.name;

        const shouldUpdateStatus = form.status !== defaultValues.status;

        if (!shouldUpdateBody && !shouldUpdateStatus) {
            toasts.addToast({
                title: 'Обновление версии',
                type: 'warning',
                description: 'Необходимо внести изменения в поля формы',
            });
            return;
        }

        handleChange(form, shouldUpdateBody, shouldUpdateStatus)

        toggle(false)
    }

    return (
        <BaseModal
            size="xl"
            isOpen={isOpen}
            toggle={() => toggle(false)}
            scrollable
            className="clients__modal"
        >
            <BaseForm<T>
                onSubmit={handleSubmit}
                defaultValues={defaultValues}
            >
                <ModalHeader toggle={() => toggle(false)}>
                    {isEditing ? 'Редактирование версии' : 'Добавление версии'}
                </ModalHeader>
                <ModalBody className="custom-scrollbar px-8 pt-8">
                        {
                            isEditing &&
                            <h6 className='mb-4'>
                                Описание
                            </h6>
                        }
                        <div className='row'>
                            <div className='col'>
                                <BaseValidatedInput
                                    label="Версия"
                                    className="mx-1"
                                    name="name"
                                    rules={{ required: requiredRule }}
                                    isFloating={true}
                                />
                            </div>
                            {
                                !isEditing && 
                                <div className='col'>
                                    <BaseValidatedDropDownList
                                        label="Платформа"
                                        name="platform"
                                        items={PLATFORMS}
                                    />
                                </div> 
                            }                    
                        </div>
                        <BaseValidatedInput
                            label="Примечания к выпуску"
                            className="mx-1"
                            name="description"
                            rules={{ required: requiredRule }}
                            isFloating={true}
                        />
                        {
                            isEditing &&
                            <div className='row'>
                                <div className='col'>
                                    <BaseValidatedDropDownList
                                        label="Статус"
                                        name="status"
                                        items={STATUSES}
                                    />
                                </div>                  
                            </div>
                        }
                </ModalBody>
                <ModalFooter className='px-8'>
                    <BaseButton type='submit' color="success" >
                        {isEditing ? 'Сохранить' : 'Добавить версию'}
                    </BaseButton>
                    <BaseButton color="secondary" onClick={() => toggle(false)}>
                        Закрыть
                    </BaseButton>
                </ModalFooter>
            </BaseForm>
        </BaseModal>
    );
};

export default VersionsEditModal;
